module.exports = __webpack_public_path__ + "static/customers-logo-40f4e47836259bbaa6e9e34ee1630371.png";